import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const ResetLibrary = () => {
  const [pw, setPw] = useState("");
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/reset-library", { password: pw, confirm: word });
      toast.success(`Library reset: ${data.deleted.items} photos and videos, ${data.deleted.albums} albums removed`);
      setPw(""); setWord("");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="settings-card" data-testid="reset-library-card">
      <h2 className="text-base font-semibold text-red-800">Reset photo library</h2>
      <p className="text-sm text-neutral-600 mt-1">
        Deletes every photo, video and album (smart, Unsorted and Year Books too), guest favourites, queues and missing-file records.
        Members, People and birthdays, settings, themes and backgrounds stay. This can't be undone.
      </p>
      <div className="flex flex-wrap gap-2 mt-3">
        <input type="password" className="input" placeholder="Your password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-library-password" />
        <input className="input" placeholder="Type RESET" value={word} onChange={(e) => setWord(e.target.value)} data-testid="reset-library-confirm" />
        <button className="btn-outline !text-red-700" disabled={busy || !pw || word !== "RESET"} onClick={go} data-testid="reset-library-button">Reset photo library</button>
      </div>
    </section>
  );
};
